export const getErrorPath = (
  err: { message: string },
  mapFieldName?: Record<string, string>
): string => {
  const [field, message] = err.message.split(': ');
  const realFieldName = mapFieldName?.[field];

  return `validationMessages.${realFieldName || field}.${message}`;
};
